import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { mainAction } from "../../Redux/Actions";
import { Select, Space } from "antd";
const SelectWardComp = React.forwardRef(
  (
    { ParentID = 0, onActive = 0, Disabled = false, onSelected = () => {} },
    ref
  ) => {
    const [data, setData] = useState([]);
    const [valueS, setValueS] = useState({});

    const onSelecteItem = (item) => {
      let dt = data.find(p=>p.value===item)
      setValueS(item);
      onSelected(dt);
    };

    const dispatch = useDispatch();
    const onGetLocation = async () => {
      if (ParentID === 0) return;
      const pr = {
        ParentID: ParentID,
        Type: 3,
      };

      const params = {
        Json: JSON.stringify(pr),
        func: "CPN_spLocation_GET",
      };
      // call redux saga
      const list = await mainAction.API_spCallServer(params, dispatch);

      let dataOptions = [];
      dataOptions.push({value:0,label:""});
      list.forEach((element, index) => {
        let option = {
          value: element.LocationId,
          label: element.Name,
          code: element.Code_Local,
        };
        dataOptions.push(option);
      });
      setData(dataOptions);
      if (onActive !== 0) {
        setValueS(onActive);
      } else setValueS(0);
    };

    useEffect(() => {
      onGetLocation();
    }, [ParentID]);

    useEffect(() => {
        setValueS(onActive);
    }, [onActive]);
    return (
      <Select
        onChange={onSelecteItem}
        style={{
          width: "100%",
        }}
        placeholder="Chọn phường xã"
        value={valueS}
        options={data}
        optionRender={(option) => (
          <Space>
            <span role="img" aria-label={option.label}>
              {option.label}
            </span>
          </Space>
        )}
        ref={ref}
        isDisabled={Disabled}
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  }
);

export const SelectWard = React.memo(SelectWardComp);
